import commeDesGarconsHommePlus2022ssFlowerExistence from "./comme-des-garcons-homme-plus-2022ss-flower-existence";
import commeDesGarconsHommePlus2020ssOrlando from "./comme-des-garcons-homme-plus-2020ss-orlando";
import commeDesGarconsLineGuide from "./comme-des-garcons-line-guide";
import maisonMargielaNumberTagGuide from "./maison-margiela-number-tag-guide";
import diorHommeHediSlimaneArchiveGuide from "./dior-homme-hedi-slimane-archive-guide";
import miucciaPradaArchiveGuide from "./miuccia-prada-archive-guide";
import yohjiYamamotoBrotherYakuzaSuitGuide from "./yohji-yamamoto-brother-yakuza-suit-guide";
import commeDesGarcons1997ssBodyMeetsDressGuide from "./comme-des-garcons-1997ss-body-meets-dress-guide";
import commeDesGarcons1982awHolesDestroyGuide from "./comme-des-garcons-1982aw-holes-destroy-guide";

export const COLLECTIONS = {
  flower: commeDesGarconsHommePlus2022ssFlowerExistence,
  orlando: commeDesGarconsHommePlus2020ssOrlando,
  cdgLineGuide: commeDesGarconsLineGuide,
  maisonMargielaNumberTagGuide: maisonMargielaNumberTagGuide,
  diorHommeHediSlimaneGuide: diorHommeHediSlimaneArchiveGuide,
  miucciaPradaArchiveGuide: miucciaPradaArchiveGuide,
  yohjiYamamotoBrotherYakuzaSuitGuide: yohjiYamamotoBrotherYakuzaSuitGuide,
  commeDesGarcons1997ssBodyMeetsDressGuide:
    commeDesGarcons1997ssBodyMeetsDressGuide,
  commeDesGarcons1982awHolesDestroyGuide:
    commeDesGarcons1982awHolesDestroyGuide,
};
